import { Button, Heading, enums as e, utils as u } from 'edrolo-ui';
import urlResolver from 'edrolo/utils/URLResolver';
import { Profile } from 'edrolo/types/Profile';
import { useProfile } from 'edrolo/domains/profile';
import Lottie from 'lottie-react';
import s from './styles.scss';
import confetti from './confetti.json';
import smiley from './smiley.json';

interface IUseProfile {
  useKeyStore: () => void;
  profile: Profile;
}

interface SubmitSuccessModalProps {
  setIsModalClosed: (isClose: boolean) => void;
}

export const SubmitSuccessModal = ({
  setIsModalClosed,
}: SubmitSuccessModalProps) => {
  const { profile }: IUseProfile = useProfile();

  return (
    <div className={s.submitSuccessModal}>
      <div className={s.animationContainer}>
        <Lottie loop={false} animationData={confetti} className={s.confetti} />
        <Lottie loop={false} animationData={smiley} className={s.smiley} />
      </div>

      <Heading.Display level={2} className={u.mb4}>
        {`Awesome work ${profile.first_name},`}
        <br />
        {`you've finished the task!`}
      </Heading.Display>

      <Button.Link
        color={e.ColorTheme.SECONDARY}
        to={urlResolver.reverse('tasks-page')}
        onClick={() => {
          setIsModalClosed(true);
        }}
      >
        Back to My tasks
      </Button.Link>
    </div>
  );
};
